import { Navigate } from "react-router-dom";
import { limpiarSesion, tokenVigente } from "../Helpers/sesion";

const PrivateRoute = ({ children }) => {
  if (tokenVigente()) return children;
  limpiarSesion();
  return <Navigate to="/" replace />;
};

export default PrivateRoute;
